import { render, staticRenderFns } from "./DialogForAddQuestion.vue?vue&type=template&id=1cd17ace&scoped=true"
import script from "./DialogForAddQuestion.vue?vue&type=script&lang=ts"
export * from "./DialogForAddQuestion.vue?vue&type=script&lang=ts"
import style0 from "./DialogForAddQuestion.vue?vue&type=style&index=0&id=1cd17ace&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd17ace",
  null
  
)

export default component.exports